import { z } from 'zod';

// Pages-Setup: Frontend und API laufen unter derselben Origin. Die
// Base-URL ist daher leer, alle apiFetch-Calls verwenden absolute Pfade
// wie "/api/touren". Der Override existiert noch, um lokal gegen einen
// abweichenden Backend-Host entwickeln zu können.
const EnvSchema = z.object({
  VITE_API_BASE_URL: z.string().default(''),
});

const parsed = EnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  throw new Error(`Invalid frontend environment: ${parsed.error.message}`);
}

export const env = parsed.data;
